import Vue from 'vue'
const MyAPI = new Vue({
  data () {
    return {
      credentials: null
    }
  },
  methods: {
    getStackTrace () {
      try {
        var err = new Error()
        return err.stack
      } catch (e) {
      }
      return ''
    },
    onError (error, err1, err2) {
      Vue.prototype.$api.hideIdle()
      if (err1) {
        error.error1 = err1
      }
      if (err2) {
        error.error2 = err2
      }
      Vue.prototype.$eventHub.$emit('errorDlg', error)
    },
    showIdle () {
      Vue.prototype.$eventHub.$emit('OnShowIdle', true)
    },
    hideIdle () {
      Vue.prototype.$eventHub.$emit('OnShowIdle', false)
    },
    resetCredentials () {
      this.credentials = null
    },
    setCredentials (credits) {
      this.credentials = credits
    },
    getCredentials () {
      return this.credentials
    },
    isCredentials () {
      if (this.credentials && this.credentials.authToken) return true
      return false
    },
    getAuthToken () {
      if (this.credentials) {
        return this.credentials.authToken
      }
      return 'local'
    }
  }
})
export default MyAPI



// WEBPACK FOOTER //
// ./src/api.js